module.exports = __webpack_public_path__ + "img/Analytic Reports.9494870c.svg";